<template>
  <div v-if="applicantProfile" id="applicant-edit-tab-personal-data">
    <div class="vx-row">
      <div class="vx-col w-full">
        <InternalProfile v-model="applicantProfile" />
        <div style="text-align: right">
          <vs-button class="mt-3" @click="save()">Speichern</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import InternalProfile from "../form/InternalProfile";
import editFormMixin from "@/mixins/editFormMixin.js";

export default {
  components: {
    InternalProfile
  },
  mixins: [
    editFormMixin({
      dataProp: "profile",
      idFields: ["consultant"]
    })
  ],
  props: {
    profileId: { type: String, required: true }
  },
  data() {
    return {
      fetchFailed: false
    };
  },
  apollo: {
    applicantProfile: {
      query: gql`
        query ApplicantProfile($id: ID!) {
          applicantProfile(id: $id) {
            id
            shortProfileDescription
            internalRatingComment
            showPicture
            exportGender
            exportName
            exportAdress
            exportShortDescription
            exportInternalRating
            exportNegotioation
            exportNameMasking
            consultant {
              id
              firstName
              lastName
            }
            commissionAmount
          }
        }
      `,
      result() {
        this.updateCurrent();
      },
      variables() {
        return {
          id: this.profileId
        };
      }
    }
  },
  computed: {
    profile: {
      get() {
        return this.applicantProfile;
      },
      // eslint-disable-next-line
      set(v) {
        this.save(false);
      }
    }
  },
  watch: {
    profile: {
      deep: true,
      handler: function(v) {
        this.profile = v;
      }
    }
  },
  methods: {
    // eslint-disable-next-line
    async persist(v = null) {
      try {
        let input = this.getInput();
        await this.$apollo.mutate({
          mutation: gql`
            mutation($id: ID!, $input: ApplicantProfileInput!) {
              updateApplicantProfile(id: $id, input: $input) {
                id
              }
            }
          `,
          variables: {
            id: this.profileId,
            input
          }
        });

        this.reportSuccess(input);
      } catch (e) {
        this.reportUnhandledError(e);
      }
    }
  }
};
</script>
